import React from 'react';
import Container from './Container';

const Modal = ({
    handleModal,
    multiProducts,
    pdf,
    cartCounterHandler,
    buttonType,
    collectionName,
    collectionDescription
}) => {
    return (
        <div className="modal forOnlyMobileAddToCart atcModalShell">
            <Container
                multiProducts={multiProducts}
                pdf={pdf}
                cartCounterHandler={cartCounterHandler}
                buttonType={buttonType}
                collectionName={collectionName}
                collectionDescription={collectionDescription}
                handleModal={handleModal}
            />
        </div>
    )
}

export default Modal;
